import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'gridref',
    templateUrl: './gridref.component.html',
    styleUrls: ['./gridref.component.scss'],
})
export class GridrefComponent implements OnInit {

    public gridRef = '';

    constructor() {
        this.gridRef = '';
    }

    ngOnInit() {
    }

}
